module.exports = __webpack_public_path__ + "5dfc4ed22af4393e8e50d6e0b33cd5a8.svg";